export const ar = {
  lastRefreshed: 'آخر تحديث',
  refreshData: 'تحديث البيانات',
  refreshingData: 'جاري التحديث...',
  notRefreshed: 'لم يتم التحديث',
  refreshedSuccessfully: 'تم تحديث البيانات بنجاح',
  refreshFailed: 'فشل التحديث',
  errorOccurred: 'حدث خطأ',
  failedToLoadData: 'فشل تحميل البيانات',
  notAvailable: 'غير متوفر',
  noSignedCharterAvailable: 'لا يوجد ميثاق موقع متاح.',
  downloaded: 'تم التحميل',
  charterDownloadedSuccessfully: 'تم تحميل الميثاق بنجاح.',
  error: 'خطأ',
  failedToDownloadCharter: 'تعذر تحميل الميثاق. يرجى المحاولة لاحقاً.',
  failedToDownloadAttachment: 'تعذر تحميل الملف. يرجى المحاولة لاحقاً.',
  fileDownloadedSuccessfully: 'تم تحميل الملف بنجاح.',
  actions: 'الإجراءات',
  studentActions: 'إجراءات الطالب',
  updateInfo: 'تحديث المعلومات',
  studentDocuments: 'مستندات الطالب',
  signCharter: 'توقيع الميثاق',
  downloadCharter: 'تحميل الميثاق',
  myApplicationsTitle: 'طلباتي',
  allChildrenApplications: 'جميع طلبات أطفالك',
  totalApplications: 'إجمالي الطلبات',
  inProgress: 'قيد الإجراء',
  accepted: 'تمت  الموافقة',
  returned: 'مرتجع',
  modified: 'تم التعديل',
  rejected: 'مرفوض',
  unknown: 'غير معروف',
  application: 'طلب',
  applicationType: 'نوع الطلب',
  dataUpdateApplication: 'طلب تحديث البيانات',
  documentUpdateApplication: 'طلب تحديث المستندات',
  studentNumber: 'رقم الطالب',
  eid: 'رقم الهوية الإماراتية',
  comment: 'التعليق',
  approved: 'معتمد',
  noApplicationsFound: 'لا توجد طلبات',
  noApplicationsRegistered: 'لا توجد طلبات مسجلة حالياً',
  noStudentsFound: 'لا توجد بيانات طلاب',
  noLinkedStudents: 'لم يتم العثور على طلاب مرتبطين بحسابك. يرجى التواصل مع المدرسة.',
  resubmit: 'إعادة تقديم',
  viewProfile: 'عرض الملف',
  lastUpdated: 'آخر تحديث:',
  login1: 'تسجيل الدخول',
  logout: 'تسجيل الخروج',
  accessibility: 'إمكانية الوصول',
  mainNavigation: 'التنقل الرئيسي',
  aboutMOE: 'عن الوزارة',
  moeStrategy: 'التوجهات الاستراتيجية',
  organizationStructure: 'الهيكل التنظيمي',
  customerHappinessCharter: 'ميثاق سعادة المتعاملين',
  uaeGovernmentCharter: 'ميثاق حكومة دولة الإمارات',
  careers: 'الوظائف',
  helpAndSupport: 'المساعدة والدعم',
  contactUs: 'اتصل بنا',
  faqs: 'الأسئلة الشائعة',
  digitalAccessibilityStatement: 'بيان سياسة الوصول الرقمي',
  sitemap: 'خريطة الموقع',
  references: 'المراجع',
  guides: 'الأدلة',
  portals: 'البوابات',
  legislations: 'التشريعات',
  quickLinks: 'الروابط السريعة',
  aboutThisWebsite: 'عن هذا الموقع',
  copyright: 'حقوق النشر',
  disclaimer: 'إخلاء المسؤولية',
  privacyPolicy: 'سياسة الخصوصية',
  termsAndConditions: 'الشروط والأحكام',
  followUsOn: ':تابعنا على',
  tollFreeNumber: ':الرقم المجاني',
  allRightsReserved: 'جميع الحقوق محفوظة',
  ministryOfEducation: 'وزارة التربية والتعليم',
  metaTitle: 'بوابة أولياء الأمور - وزارة التربية والتعليم',
  metaDescription: 'بوابة شاملة لأولياء الأمور لمتابعة التحصيل الأكاديمي والحضور والتواصل المدرسي لأبنائهم.',
  appleWebAppTitle: 'بوابة أولياء الأمور',
  loadingChildData: 'جارٍ تحميل معلومات الطفل',
  downloadFile: 'تنزيل الملف',
  removeFile: 'إزالة الملف',
  uploadFile: 'رفع ملف',
  formatLabel: 'الصيغة:',
  maxFileSizeLabel: 'الحد الأقصى لحجم الملف:',
  fileSizeExceededError: 'حجم الملف يتجاوز الحد الأقصى المسموح به ({maxMb} ميجابايت)',
  fileTypeInvalidError: 'صيغة الملف غير صالحة. الصيغ المسموح بها: {formats}',
  previousDocumentPrompt: 'عزيزي المستخدم، لقد قمت سابقاً بإرفاق مستند من نوع مماثل. هل ترغب في إعادة إرفاقه؟',
  viewDocument: 'عرض المستند',
  useDocument: 'استخدام المستند',
  noThanks: 'لا، شكراً',
  additionalInformation: 'معلومات إضافية',
  parentCategoryCautionTitle: 'تنبيه هام',
  parentCategoryCautionText:
    'يرجى اختيار الفئة الصحيحة، حيث يحدد ذلك المستندات المطلوبة. يتطلب موظفو وزارة التربية والتعليم ووظائف إمام المسجد مستندات إضافية، بينما يتم اختيار *أخرى* لجميع الحالات الأخرى. لا يمكن تغيير هذا الاختيار بعد تقديم الطلب.',
  parentCategoryLabel: 'فئة ولي أمر الطالب:',
  selectCategory: '-- اختر الفئة --',
  imamMosque: 'إمام مسجد',
  moeEmployee: 'موظف في وزارة التربية والتعليم',
  other: 'أخرى',
  continue: 'متابعة',
  submit: 'إرسال',
  back: 'رجوع',
  requiredDocuments: 'المستندات المطلوبة:',
  noRequiredDocuments: 'لا توجد مستندات مطلوبة',
  additionalDocuments: 'مستندات إضافية:',
  noAdditionalDocuments: 'لا توجد مستندات إضافية',
  fillRequiredDocumentsError: 'يرجى تحميل أو تحديد جميع المستندات المطلوبة',
  documentsUpdateSuccess: 'تم إرسال طلب تحديث المستندات بنجاح',
  documentsUpdateFailed: 'فشل إرسال طلب تحديث المستندات',
  nav: {
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    summary: 'الملخص',
    myApplications: 'طلباتي',
    messages: 'الرسائل',
    announcements: 'الإعلانات',
    calendar: 'التقويم',
    profile: 'الملف الشخصي',
  },
  common: {
    close: 'إغلاق',
    switchLanguage: 'تبديل اللغة',
    english: 'الإنجليزية',
    arabic: 'العربية',
    otherLanguages: 'لغات أخرى',
    translationDisclaimer:
      'تعتمد قائمة "اللغات الأخرى" المذكورة أعلاه على Google Translate لإنشاء ترجمة آلية للمحتوى بغرض العرض. لا يتم ضمان دقة الترجمة الآلية.',
    search: 'بحث',
    clear: 'مسح',
    cancel: 'إلغاء',
    save: 'حفظ',
    saving: 'جاري الحفظ...',
    send: 'إرسال',
    sendMessage: 'إرسال رسالة',
    today: 'اليوم',
    export: 'تصدير',
    month: 'شهر',
    list: 'قائمة',
    more: 'المزيد',
    postedBy: 'نُشر بواسطة',
    due: ':الموعد',
    children: 'الأطفال',
    attendanceRate: 'نسبة الحضور',
    redirecting: 'جارٍ التحويل إلى لوحة التحكم...',
    loading: 'جاري التحميل...',
  },
  dashboard: {
    title: 'لوحة التحكم',
    welcome: 'مرحبًا بعودتك! إليك ما يحدث مع أطفالك.',
    attendance: 'الحضور',
    latestGrade: 'آخر درجة',
    nextEvent: 'الحدث القادم',
    recentAnnouncements: 'الإعلانات الأخيرة',
    viewAll: 'عرض الكل',
    noRecentAnnouncements: 'لا توجد إعلانات حديثة',
    upcomingEvents: 'الأحداث القادمة',
    viewCalendar: 'عرض التقويم',
    noUpcomingEvents: 'لا توجد أحداث قادمة',
  },
  student: {
    viewDetails: 'عرض التفاصيل',
    personalInfo: 'المعلومات الشخصية',
    academicInfo: 'المعلومات الأكاديمية',
    contactInfo: 'معلومات الاتصال',
    nationality: 'الجنسية',
    gender: 'الجنس',
    birthDate: 'تاريخ الميلاد',
    studentId: 'رقم الطالب',
    grade: 'الصف',
    class: 'الفصل',
    male: 'ذكر',
    female: 'أنثى',
    age: 'العمر',
    years: 'سنة',
  },
  announcements: {
    title: 'الإعلانات',
    subtitle: 'ابقَ على اطلاع بإعلانات المدرسة والصف',
    searchPlaceholder: 'ابحث في الإعلانات...',
    allCategories: 'كل الفئات',
    allTags: 'كل الوسوم',
    showing: 'عرض',
    of: 'من',
    announcementsLower: 'الإعلانات',
    noResultsTitle: 'لا توجد إعلانات',
    noResultsFilters: 'جرّب تعديل عوامل التصفية لعرض المزيد من الإعلانات',
    noResultsNone: 'لا توجد إعلانات في هذا الوقت',
    clearFilters: 'مسح عوامل التصفية',
    loadMore: 'تحميل المزيد من الإعلانات',
    categories: {
      all: 'الكل',
      school: 'المدرسة',
      class: 'الصف',
      urgent: 'عاجل',
    },
  },
  messages: {
    title: 'الرسائل',
    subtitle: 'تواصل مع المعلمين وطاقم المدرسة',
    newMessage: 'رسالة جديدة',
    conversations: 'المحادثات',
    searchPlaceholder: 'ابحث في المحادثات...',
    noConversationsTitle: 'لا توجد محادثات',
    noConversationsDesc: 'ابدأ محادثة جديدة مع معلم',
    selectConversationTitle: 'اختر محادثة',
    selectConversationDesc: 'اختر محادثة من القائمة لعرض الرسائل',
    dialog: {
      newMessage: 'رسالة جديدة',
      description: 'ابدأ محادثة مع معلم أو أحد أفراد الطاقم.',
      to: 'إلى',
      subject: 'الموضوع',
      message: 'الرسالة',
      selectTeacher: 'اختر معلماً...',
      enterSubject: 'أدخل الموضوع...',
      typeMessage: 'اكتب رسالتك...',
    },
  },
  calendar: {
    title: 'التقويم',
    subtitle: 'اعرض الأحداث القادمة والاختبارات والتواريخ المهمة',
    month: 'شهر',
    list: 'قائمة',
    export: 'تصدير',
    today: 'اليوم',
    upcomingEvents: 'الأحداث القادمة',
    legend: {
      event: 'حدث',
      exam: 'اختبار',
      holiday: 'عطلة',
      meeting: 'اجتماع',
    },
    daysShort: ['أحد', 'اثن', 'ثلث', 'أرب', 'خمس', 'جمع', 'سبت'],
    more: 'المزيد',
    exportGoogle: 'تصدير إلى تقويم Google',
    exportOutlook: 'تصدير إلى Outlook',
  },
  profile: {
    title: 'الملف الشخصي والإعدادات',
    subtitle: 'إدارة معلومات حسابك وتفضيلاتك',
    personalInfo: 'المعلومات الشخصية',
    edit: 'تعديل',
    fullName: 'الاسم الكامل',
    emailAddress: 'عنوان البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    saveChanges: 'حفظ التغييرات',
    cancel: 'إلغاء',
    parentAccount: 'حساب ولي الأمر',
    linkedChildren: 'الأطفال المرتبطون',
    linkedChildrenSubtitle: 'الأطفال المرتبطون بحسابك',
    active: 'نشط',
    notificationPreferences: 'تفضيلات الإشعارات',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    emailNotificationsDesc: 'تلقي التحديثات عبر البريد الإلكتروني',
    smsNotifications: 'إشعارات الرسائل القصيرة',
    smsNotificationsDesc: 'تلقي التحديثات عبر الرسائل النصية',
    pushNotifications: 'إشعارات المتصفح',
    pushNotificationsDesc: 'تلقي إشعارات المتصفح',
    accountActions: 'إجراءات الحساب',
    changePassword: 'تغيير كلمة المرور',
    missingEmiratesIdTitle: 'الهوية الإماراتية مطلوبة',
    missingEmiratesIdMessage:
      'ملفك الشخصي في تطبيق الهوية الرقمية UAE Pass لا يحتوي على رقم الهوية الإماراتية. يرجى تحديث ملفك الشخصي في تطبيق UAE Pass بإضافة رقم الهوية الإماراتية للوصول إلى جميع الميزات والخدمات.',
    updateUAEPass: 'تحديث ملف UAE Pass',
    privacySettings: 'إعدادات الخصوصية',
    downloadData: 'تنزيل بياناتي',
    deactivateAccount: 'تعطيل الحساب',
    updatedSuccess: 'تم تحديث الملف الشخصي بنجاح!',
  },
  login: {
    title: 'بوابة أولياء الأمور',
    subtitle: 'سجّل الدخول إلى حسابك',
    emailAddress: 'عنوان البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    signIn: 'تسجيل الدخول',
    signingIn: 'جارٍ تسجيل الدخول...',
    needHelp: 'هل تحتاج مساعدة للوصول إلى حسابك؟',
    contactSupport: 'اتصل بالدعم',
    demoCreds: 'بيانات تجريبية: أي بريد وكلمة مرور ستعمل',
  },
  footer: {
    rights: 'جميع الحقوق محفوظة.',
    tagline: 'ربط أولياء الأمور بتعليم أبنائهم.',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    support: 'الدعم',
    accessibility: 'إمكانية الوصول',
  },
  home: {
    redirecting: 'جارٍ التحويل إلى لوحة التحكم...',
  },
  child: {
    loading: 'جاري التحميل...',
    error_loading_child_data: 'حدث خطأ أثناء تحميل بيانات الطفل.',
    no_data_available_for_child: 'لا توجد بيانات متاحة لهذا الطفل.',
    child_not_found: 'الطفل غير موجود.',
    child_profile: 'ملف الطفل',
    basic_information: 'المعلومات الأساسية',
    given_name: 'الاسم الأول',
    family_name: 'اسم العائلة',
    username: 'اسم المستخدم',
    identifier: 'الهوية الإماراتية',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    role: 'الدور',
    status: 'الحالة',
    sourced_id: 'المعرف المصدر',
    last_modified: 'آخر تعديل',
    demographics_and_names: 'البيانات الديموغرافية والأسماء',
    gender: 'الجنس',
    birth_date: 'تاريخ الميلاد',
    nationality_en: 'الجنسية (إنجليزي)',
    nationality_ar: 'الجنسية (عربي)',
    arabic_name: 'الاسم بالعربية',
    english_name: 'الاسم بالإنجليزية',
    primary_address: 'العنوان الرئيسي',
    country: 'الدولة',
    state: 'الامارة',
    city: 'المدينة',
    zip_code: 'الرمز البريدي',
    po_box: 'صندوق البريد',
    region: 'المنطقة',
    sector: 'القطاع',
    address_lines: 'خطوط العنوان',
    road_number: 'رقم الطريق',
    plot_id: 'معرف القطعة',
    plot_number: 'رقم القطعة',
    no_address_available: 'لا يوجد عنوان متاح',
    basic_info_subtitle: 'معلومات التعريف الشخصية وتفاصيل الاتصال',
    address_info_subtitle: 'معلومات العنوان السكني الحالي',
    no_address_title: 'لا توجد معلومات عنوان',
    student_number: 'رقم الطالب',
    religion: 'الديانة',
    citizenship_status: 'حالة المواطنة',
    middle_name: 'الاسم الأوسط',
    third_name: 'الاسم الثالث',
    fourth_name: 'الاسم الرابع',
    birth_place_city: 'مدينة الميلاد',
    birth_place_country: 'بلد الميلاد',
    nationality_info: 'الجنسية والمواطنة',
    nationality_subtitle: 'بلد المنشأ وتفاصيل المواطنة',
    birth_info: 'معلومات الميلاد',
    birth_info_subtitle: 'تاريخ ومكان الميلاد',
    parent_info: 'معلومات ولي الأمر',
    parent_info_subtitle: 'تفاصيل الاتصال بولي الأمر أو الوصي',
    parent_name: 'اسم ولي الأمر',
    parent_id: 'رقم هوية ولي الأمر',
    parent_email: 'البريد الإلكتروني لولي الأمر',
    parent_phone: 'رقم هاتف ولي الأمر',
    parent_enabled: 'حالة الحساب',
    parent_enabled_yes: 'نشط',
    parent_enabled_no: 'غير نشط',
    no_parent_info: 'لا توجد معلومات عن ولي الأمر',
    notFoundTitle: 'الطفل غير موجود',
    notFoundDesc: 'الطفل الذي تبحث عنه غير موجود أو ليس لديك صلاحية لعرض معلوماته.',
    goToDashboard: 'الذهاب إلى لوحة التحكم',
    breadcrumbChildren: 'الأطفال',
    selectChild: 'اختر الطفل',
    yourChildren: 'أطفالك',
    attendanceRate: 'نسبة الحضور',
    tabs: {
      overview: 'نظرة عامة',
      attendance: 'الحضور',
      grades: 'الدرجات',
      assignments: 'الواجبات',
    },
    attendanceSummary: 'ملخص الحضور',
    present: 'حاضر',
    late: 'متأخر',
    absent: 'غائب',
    latestGrades: 'أحدث الدرجات',
    upcomingAssignments: 'الواجبات القادمة',
    due: ':الموعد',
    attendanceCalendar: 'تقويم الحضور',
    attendanceCalendarSubtitle: 'عرض شهري لسجلات الحضور',
    attendanceLegend: {
      present: 'حاضر',
      late: 'متأخر',
      absent: 'غائب',
    },
    gradesAndTests: 'الدرجات والاختبارات',
    gradesAndTestsSubtitle: 'أحدث الدرجات والواجبات',
    downloading: 'جارٍ التنزيل...',
    downloadReportCard: 'تنزيل كشف الدرجات',
    table: {
      subject: 'المادة',
      assignment: 'الواجب',
      grade: 'الدرجة',
      date: 'التاريخ',
      teacher: 'المعلم',
    },
    assignmentsTitle: 'الواجبات',
    assignmentsSubtitle: 'جميع الواجبات مع تواريخ الاستحقاق والحالة',
    updateInfo: {
      title: 'تحديث معلومات الطالب',
      intro: {
        init: 'يرجى مراجعة وتحديث بيانات التواصل والعنوان والمواصلات الخاصة بابنك قبل توقيع ميثاق السلوك.',
        edit: 'نحتاج إلى بعض التعديلات قبل المتابعة. يرجى تحديث البيانات أدناه وإعادة الإرسال للمتابعة إلى ميثاق السلوك.',
      },
      modeLabel: {
        init: 'طلب جديد',
        edit: 'بحاجة إلى تصحيح',
      },
      contactSection: {
        title: 'أرقام التواصل',
        description: 'تأكد من توفر رقم هاتف محدّث للتواصل معك في الحالات الطارئة.',
        primaryLabel: 'رقم التواصل الرئيسي (المرتبط بالهوية الرقمية)',
        secondaryLabel: 'رقم تواصل إضافي',
        addButton: 'إضافة رقم آخر',
        removeButton: 'إزالة الرقم',
      },
      addressSection: {
        title: 'بيانات الطالب',
        description:
          'تأكد من أن العنوان المسجل لدينا ما زال صحيحًا. إذا تغيّر، يرجى إدخال العنوان الجديد وإرفاق مستند داعم.',
        currentLabel: 'العنوان الحالي ',
        changeToggle: 'هل سيتم تغيير عنوان السكن؟',
        newAddressLabel: 'تفاصيل العنوان الجديد',
        newAddressPlaceholder: 'اكتب العنوان السكني المحدّث، بما في ذلك المبنى والشارع والمنطقة والإمارة.',
        documentLabel: 'إرفاق إثبات العنوان (PDF)',
        documentHelper: 'أرفق فاتورة خدمات حديثة أو عقد إيجار أو مستندًا رسميًا يوضح العنوان الجديد.',
        summaryLabel: 'معاينة العنوان الجديد',
        summaryPending: 'اختر العنوان لعرض التفاصيل هنا.',
        badge: {
          idle: 'بانتظار التحديد',
          saving: 'جارٍ الحفظ...',
          saved: 'تم الحفظ',
          error: 'فشل الحفظ',
        },
        summaryFields: {
          houseNumber: 'رقم المبنى / المنزل',
          streetName: 'اسم الشارع',
          plotNumber: 'رقم القطعة',
          mainPlot: 'القطعة الرئيسية',
          premises: 'المنشأة',
          latitude: 'خط العرض',
          longitude: 'خط الطول',
          areaName: 'المنطقة',
          zoneName: 'النطاق',
          regionName: 'الإقليم',
          emirateName: 'الإمارة',
        },
        summaryMissing: 'غير متوفر',
        autoSaveHint: 'يتم حفظ العناوين الجديدة تلقائياً فور اختيارها.',
        errorRetry: 'يرجى إعادة اختيار العنوان.',
      },
      transportationSection: {
        title: 'مواصلات الطالب',
        description: 'أخبرنا بكيفية انتقال ابنك من وإلى المدرسة.',
        selectLabel: 'طريقة المواصلات',
        options: {
          car: 'سيارة العائلة',
          bus: 'حافلة المدرسة',
          public: 'وسائل النقل العامة',
          other: 'أخرى',
        },
        otherLabel: 'وصف طريقة المواصلات',
      },
      validation: {
        primaryContact: 'يرجى إدخال رقم تواصل واحد على الأقل.',
        addressDetails: 'يرجى إدخال تفاصيل العنوان الجديد.',
        document: 'يرجى إرفاق مستند يثبت العنوان الجديد.',
        transportation: 'يرجى اختيار طريقة المواصلات.',
        otherTransportation: 'يرجى وصف طريقة المواصلات.',
      },
      submit: {
        continue: 'متابعة',
        submitting: 'جارٍ التحضير...',
        cancel: 'العودة إلى ملف الطالب',
      },
      fileNameLabel: 'اسم الملف',
      fileReplace: 'استبدال الملف',
      noFileSelected: 'لم يتم اختيار ملف',
    },
  },
  pickLocation: {
    title: 'اختر الموقع',
    emirate: 'الإمارة',
    region: 'المدينة',
    zone: 'المنطقة',
    area: 'القطاع',
    streetName: 'رقم / اسم الشارع',
    houseNumber: 'رقم المنزل',
    requiredField: 'الحقل مطلوب',
    loading: 'جاري التحميل...',
    noRegions: 'لا توجد مدن متاحة',
    noZones: 'لا توجد مناطق متاحة',
    noAreas: 'لا توجد قطاعات متاحة',
  },
  admin: {
    title: 'لوحة التحكم الإدارية',
    configuration: 'الإعدادات',
    verifyingAccess: 'جارٍ التحقق من صلاحية الوصول...',
    accessDenied: 'تم رفض الوصول',
    noPermission: 'ليس لديك صلاحية للوصول إلى هذه الصفحة.',
    redirecting: 'جارٍ التحويل إلى لوحة التحكم...',
    loggedInAs: 'تم تسجيل الدخول كـ',
    backToPortal: 'العودة إلى البوابة',
    portal: 'البوابة',
    navigation: {
      analytics: 'التحليلات',
      analyticsDesc: 'نظرة عامة على النظام والإحصائيات',
      students: 'الطلاب',
      studentsDesc: 'دليل الطلاب والمعلومات',
      logs: 'سجلات التحديثات',
      logsDesc: 'تتبع النشاط والتحديثات',
      users: 'مستخدمو الإدارة',
      usersDesc: 'إدارة صلاحيات الوصول الإدارية',
      periods: 'فترات التحديث',
      periodsDesc: 'تكوين نوافذ التحديث',
      academicYear: 'السنة الأكاديمية',
      academicYearDesc: 'تعيين السنة الأكاديمية النشطة',
      actions: 'إجراءات الطلاب',
      actionsDesc: 'إدارة إجراءات الطلاب',
      resilience: 'مرونة واجهات البرمجة',
      resilienceDesc: 'مراقبة صحة النظام والأداء',
    },
    analytics: {
      title: 'نظرة عامة على تحليلات النظام',
      subtitle: 'عرض شامل لبيانات النظام والديموغرافيا والنشاط',
    },
  },
  notifications: {
    title: 'الإشعارات',
    subtitle: 'ابقَ على اطلاع بالمعلومات المهمة حول أطفالك',
    unread: 'غير مقروءة',
    total: 'الإجمالي',
    new: 'جديد',
    read: 'مقروء',
    unreadStatus: 'غير مقروء',
    markAllRead: 'تعليم الكل كمقروء',
    markAllAsRead: 'تعليم الكل كمقروء',
    viewAll: 'عرض جميع الإشعارات',
    seeAllActivity: 'عرض جميع الأنشطة الواردة',
    noNotifications: 'لا توجد إشعارات',
    noNotificationsDesc: 'أنت على اطلاع بكل شيء! لا توجد إشعارات جديدة في الوقت الحالي.',
    refresh: 'تحديث',
    loadMore: 'تحميل المزيد',
    student: 'الطالب',
    status: 'الحالة',
    filters: 'الفلاتر',
    filterByStatus: 'تصفية حسب الحالة',
    filterByType: 'تصفية حسب النوع',
    all: 'الكل',
    allTypes: 'جميع الأنواع',
    showing: 'عرض',
    of: 'من',
    // Notification types
    types: {
      info: 'معلومات',
      success: 'نجاح',
      warning: 'تحذير',
      error: 'خطأ',
      enrollment: 'التسجيل',
      update: 'تحديث',
      conduct: 'سلوك',
      announcement: 'إعلان',
      StatusChange: 'تغيير الحالة',
      AddressUpdate: 'تحديث العنوان',
      ContactUpdate: 'تحديث جهة الاتصال',
      TransportationUpdate: 'تحديث النقل',
      DataUpdate: 'تحديث البيانات',
    },
    // Time formats
    time: {
      justNow: 'الآن',
      minutesAgo: 'منذ دقائق',
      hoursAgo: 'منذ ساعات',
      daysAgo: 'منذ أيام',
      weeksAgo: 'منذ أسابيع',
      monthsAgo: 'منذ أشهر',
    },
    // Actions
    actions: {
      markAsRead: 'تعليم كمقروء',
      markAsUnread: 'تعليم كغير مقروء',
      delete: 'حذف',
      viewDetails: 'عرض التفاصيل',
    },
    // Toast notifications
    toast: {
      newNotification: 'إشعار جديد',
      newNotifications: 'إشعارات جديدة',
      youHave: 'لديك',
      new: 'جديد',
      notification: 'إشعار',
      notifications: 'إشعارات',
    },
  },
  parentConduct: {
    title: 'ميثاق الشراكة بين المدرسة وولي الأمر',
    subtitle: 'وزارة التربية والتعليم - الإمارات العربية المتحدة',
    backButton: 'الرجوع',
    progress: 'التقدم',
    loading: 'جاري تحميل بيانات الميثاق...',
    noStudentId: 'لا يمكن عرض الصفحة بدون معرف الطالب.',
    errorLoading: 'تعذر تحميل البيانات المطلوبة.',
    steps: {
      schoolInfo: 'معلومات المدرسة',
      parentInfo: 'معلومات ولي الأمر',
      terms: 'أحكام الميثاق',
      signature: 'التوقيع',
    },
    progressLabels: {
      current: 'المرحلة:',
      of: 'من',
    },
    introduction: {
      title: 'مقدمة',
      paragraph1:
        'في إطار تفعيل الشراكة الفاعلة بين المدرسة وولي الأمر وتعزيز دورهما في دعم التحصيل وسلوك أبنائنا الطلبة، يهدف هذا الميثاق إلى توضيح الأدوار والمسؤوليات المتبادلة بين الطرفين بما يضمن توفير بيئة تعليمية آمنة ومحفزة.',
      paragraph2:
        'ويعد توقيع ولي الأمر على هذا الميثاق إقرارًا بالاطلاع على بنوده وفهمها والالتزام بمقتضاها، كما يمثل اتفاقًا على التعاون البناء مع المدرسة لتحقيق مخرجات تعليمية وسلوكية متميزة لأبنائنا وبناتنا.',
    },
    schoolSection: {
      title: 'معلومات المدرسة',
      schoolName: 'اسم المدرسة',
      schoolId: 'معرف المدرسة',
      address: 'العنوان',
      phone: 'رقم الهاتف',
      email: 'البريد الإلكتروني',
      schoolYear: 'السنة الدراسية',
      gradeClass: 'الصف الدراسي والشعبة',
      studentName: 'اسم الطالب/ـة',
      nationalId: 'الهوية الإماراتية',
      studentSystemId: 'معرف الطالب في النظام',
      routeId: 'معرف المسار (Route ID)',
    },
    parentSection: {
      title: 'معلومات للآباء والطلاب',
      parentData: 'بيانات ولي الأمر',
      parentName: 'اسم ولي الأمر',
      parentNationalId: 'الهوية الإماراتية',
      parentAddress: 'العنوان',
      contactNumber: 'رقم التواصل',
      parentEmail: 'البريد الإلكتروني',
      linkedStudentData: 'بيانات الطالب المرتبطة',
      studentFullName: 'اسم الطالب/ـة الكامل',
    },
    termsSection: {
      validityTitle: 'مدة وصلاحية هذا الميثاق:',
      validityText: 'سنة دراسية واحدة تبدأ من تاريخ الإقرار على الميثاق.',
      schoolCommitmentsTitle: 'التزامات المدرسة',
      parentCommitmentsTitle: 'التزامات ولي الأمر',
      categories: {
        basicRequirements: 'المتطلبات الأساسية',
        behaviorDiscipline: 'السلوك والانضباط',
        qualityOfLife: 'جودة حياة الطلبة / الصحة والسلامة',
        citizenship: 'المواطنة الإيجابية والهوية الوطنية',
        academicAchievement: 'التحصيل الدراسي والمناهج والبرامج التعليمية',
        assessment: 'التقييم والامتحانات',
        activities: 'الأنشطة والرعاية الطلابية',
        transportation: 'المواصلات',
        uniform: 'الزي المدرسي',
        publicProperty: 'الممتلكات العامة بالمدرسة',
        behavior: 'السلوك',
      },
    },
    signatureSection: {
      title: 'التوقيع والاعتماد',
      summaryTitle: 'ملخص البيانات',
      school: 'المدرسة:',
      student: 'الطالب:',
      parent: 'ولي الأمر:',
      grade: 'الصف:',
      parentDeclaration: 'إقرار ولي الأمر:',
      declarationText:
        'أقر بأنني اطلعت على جميع بنود ميثاق الشراكة بين المدرسة وولي الأمر، وفهمت محتواها بالكامل، وأتعهد بالالتزام بجميع البنود والشروط المذكورة أعلاه، والتعاون مع المدرسة لضمان تحقيق المصلحة الفضلى لابني/ابنتي.',
      ministryStamp: 'ختم وزارة التربية والتعليم',
      approved: 'معتمد',
      date: 'التاريخ',
    },
    navigation: {
      previous: 'السابق',
      next: 'التالي',
      close: 'إغلاق',
    },
    placeholder: '—',
    conductTerms: {
      validityPeriod: 'سنة دراسية واحدة تبدأ من تاريخ الإقرار على الميثاق.',
      schoolCommitments: {
        title: 'التزامات المدرسة',
        sections: [
          {
            title: 'المتطلبات الأساسية',
            items: [
              'ضمان بيئة مدرسية قائمة على المساواة وتكافؤ الفرص بين الطلبة كافة.',
              'اطلاع أولياء الأمور على نتائج التقييمات والإجراءات المعتمدة لرفع مستوى أداء أبنائهم.',
              'إبلاغ أولياء الأمور عن سلوكيات أبنائهم الإيجابية، بالإضافة إلى مخالفاتهم السلوكية.',
              'تعريف أولياء أمور الطلبة من فئة أصحاب الهمم بحقوقهم وواجباتهم وتوفير بيئة تعليمية غنية وداعمة ومرافق مجهزة ومعدلة تلائم احتياجاتهم.',
              'ضمان توفير بيئة مدرسية آمنة وشاملة تضمن سلامة الطلبة.',
              'وضع الإرشادات الخاصة بصحة الطلبة وتوعيتهم بأهمية تبني عادات وأنماط الحياة الصحية.',
              'بناء قنوات تواصل فعالة مع أولياء الأمور لإبلاغهم بالمستجدات من التعليمات أو الإجراءات أو اللوائح ومشاركتهم بالمعلومات المهمة بالإضافة إلى اطلاعهم على أخبار المدرسة.',
              'الشفافية والعدالة في تنفيذ الإجراءات والسياسات مع الحفاظ على سرية المعلومات وبيانات الطلبة.',
            ],
          },
          {
            title: 'السلوك والانضباط',
            items: [
              'تطبيق القرار الوزاري رقم (851) لسنة 2018 بشأن لائحة إدارة سلوك الطلبة في مؤسسات التعليم العام الطلبة بعدالة وشفافية، مع توعية الطلبة وأولياء أمورهم بالعواقب المترتبة على المخالفات.',
              'متابعة انتظام الطلبة في الحضور والانصراف وفق المواعيد الرسمية والأدلة الإجرائية، واتخاذ الإجراءات المناسبة عند وجود تأخير أو غياب غير مبرر.',
              'الالتزام باحترام أولياء الأمور، وبناء قنوات تواصل فعّالة معهم لإبلاغهم بالمستجدات المتعلقة بالتعليمات والإجراءات واللوائح، ومشاركتهم بالمعلومات المهمة، وإطلاعهم على أخبار المدرسة بانتظام.',
            ],
          },
          {
            title: 'جودة حياة الطلبة / الصحة والسلامة',
            items: [
              'توفير بيئة مدرسية صحية وآمنة تتوافق مع معايير الامن والسلامة.',
              'تنظيم برامج توعية لتعزيز النظافة الشخصية والصحة العامة للطلبة.',
              'حفظ السجلات الطبية الخاصة بالطلبة والتنسيق مع أولياء الأمور بشأن أي حالات صحية.',
            ],
          },
          {
            title: 'المواطنة الإيجابية والهوية الوطنية',
            items: [
              'تنظيم فعاليات لتعزيز قيم المواطنة الصالحة والمسؤولية الاجتماعية لدى الطلبة.',
              'غرس الاعتزاز بالهوية الوطنية والقيم الإنسانية مثل الاحترام والتسامح والتعايش المشترك من خلال الأنشطة المختلفة.',
            ],
          },
          {
            title: 'التحصيل الدراسي والمناهج والبرامج التعليمية',
            items: [
              'تحديث بيانات الطلبة بشكل دوري في أنظمة الوزارة.',
              'متابعة الأداء الأكاديمي للطلبة بانتظام، وإشراك أولياء الأمور في نتائج التقييمات والإجراءات المعتمدة لرفع مستوى أبنائهم.',
              'إعداد وتنفيذ خطط تربوية فردية للطلبة من أصحاب الهمم بالتعاون مع أسرهم.',
              'الشفافية والعدالة في تنفيذ الإجراءات والسياسات مع الحفاظ على سرية المعلومات وبيانات الطلبة.',
            ],
          },
          {
            title: 'التقييم والامتحانات',
            items: [
              'تطبيق سياسة التقييم المعتمدة والالتزام بالمواعيد الرسمية للتقييمات والامتحانات.',
              'متابعة نتائج الطلبة بشكل مستمر وتقديم التغذية الراجعة.',
              'ضمان جاهزية بيئة الامتحانات وتوفير الأدوات والأجهزة اللازمة.',
              'منع أي ممارسات تتعلق بالغش أو تسريب الأسئلة، واتخاذ الإجراءات الرادعة عند وقوعها.',
            ],
          },
          {
            title: 'الأنشطة والرعاية الطلابية',
            items: [
              'توفير أنشطة صفية ولاصفية متنوعة لاكتشاف وتنمية مهارات الطلبة.',
              'تشجيع الطلبة على المشاركة في المبادرات الوطنية والبرامج التطوعية وخدمة المجتمع.',
            ],
          },
          {
            title: 'المواصلات',
            items: [
              'الإشراف على خدمات النقل المدرسي الخاصة بالمدرسة وضمان الالتزام بمعايير السلامة.',
              'متابعة سلوك الطلبة في الحافلات واتخاذ الإجراءات التربوية عند حدوث مخالفات.',
            ],
          },
          {
            title: 'الزي المدرسي',
            items: [
              'توعية أولياء الأمور بدليل الزي المدرسي وقنوات البيع الرسمية للزي المدرسي الموحد.',
              'متابعة التزام الطلبة بالزي والمظهر اللائق أثناء الدوام المدرسي.',
            ],
          },
          {
            title: 'الممتلكات العامة بالمدرسة',
            items: [
              'تعزيز وعي الطلبة بأهمية المحافظة على الممتلكات العامة والمرافق المدرسية.',
              'مراقبة استخدام الطلبة للمرافق وضمان حمايتها من العبث أو التخريب.',
              'تطبيق الإجراءات المناسبة في حال حدوث أضرار، بالتنسيق مع أولياء الأمور.',
            ],
          },
        ],
      },
      parentCommitments: {
        title: 'التزامات ولي الأمر',
        sections: [
          {
            title: 'السلوك',
            items: [
              'تشجيع أبنائهم على تبني القيم الأخلاقية والتربوية وتعزيز السُّلوك الايجابي لديهم وتحفيزهم على التعلم والالتزام بالقوانين واحترام جميع العاملين في المدرسة.',
              'الاطلاع على لائحة إدارة سلوك الطلبة في مؤسسات التعليم الحكومية الاتحادية المعتمدة، وتوعية وارشاد أبنائهم على ضرورة الالتزام بها والعواقب التي تترتب على مخالفتها.',
              'حث الطلبة على الالتزام بمواعيد الحضور والانصراف والإلمام بالنتائج المترتبة على التأخير وعدم الالتزام بالحضور المبكر للمدرسة.',
              'حث الطلبة على الالتزام بمواعيد الحضور والانصراف والإلمام بالنتائج المترتبة على الغياب بدون عذر.',
              'الالتزام بتعليمات المدرسة عند الحضور لطلب خدمة أو لمناقشة مشكلة أو تسوية أية نزاعات.',
            ],
          },
          {
            title: 'جودة حياة الطلبة / الصحة والسلامة',
            items: [
              'توفير بيئة صحية تشمل معايير الأغذية الصحية، وأصناف الطعام والشراب المسموح بها في المدرسة.',
              'توفير الوقت الكافي للنوم والاسترخاء والراحة النفسية لأبنائهم في بيئة عائلية مستقرة.',
              'التوعية حول النظافة الشخصية للأبناء.',
              'التحفيز على ممارسة الأنشطة البدنية من خلال التحرك واللعب.',
              'تقديم المساعدة والدعم للأبناء في حل المشاكل الشخصية والعاطفية والدراسية.',
              'توفير كافة التقارير الطبية المتعلقة بالطالب وسيرته المرضية لإدارة المدرسة.',
              'المشاركة الفعالة من خلال الإجابة على الاستبانات المرسلة من قبل الوزارة أو المدرسة.',
            ],
          },
          {
            title: 'المواطنة الإيجابية والهوية الوطنية',
            items: [
              'الالتزام بتعزيز المواطنة الصالحة والمسؤولية الاجتماعية لدى الأبناء وتحفيزهم على القيام بالواجبات والمسؤوليات الوطنية، وتشجيعهم على المشاركة الفعالة في الحياة الاجتماعية والأعمال الخيرية والتطوعية.',
              'الالتزام بتحفيز الأبناء على الاعتزاز بهويتهم الوطنية، والتحلّي بالأخلاق والقيم الإنسانية الأساسية كالاحترام والتسامح والتعايش المشترك بين المواطنين والمقيمين.',
            ],
          },
          {
            title: 'التحصيل الدراسي والمناهج والبرامج التعليمية',
            items: [
              'تحديث بيانات الأبناء حسب الإجراءات والشروط والأحكام المعتمدة في الوزارة.',
              'يلتزم ولي الأمر بتوفير جهاز الحاسب الآلي حسب الاجراءات المواصفات المعتمدة في الوزارة مع الالتزام بالمعايير والشروط الخاصة بسياسة استخدام الحاسوب.',
              'التواصل مع إدارة المدرسة لمتابعة أداء أبنائهم في الدراسة وتقديم الدعم لهم.',
              'تحفيز الأبناء على الدراسة، وتحديد الأهداف الواضحة لهم، وإرشادهم، وإظهار أهمية التعليم في حياتهم المستقبلية.',
              'تهيئة الجو الأسري وتخصيص الوقت الكافي للدراسة والتحضير والاستعداد للامتحانات مع ضمان الوقت الكافي للراحة.',
              'متابعة الطلبة من فئة أصحاب الهمم في أداء واجباتهم حسب الخطة التربوية الفردية المعتمدة.',
            ],
          },
          {
            title: 'التقييم والامتحانات',
            items: [
              'الاطلاع على سياسة التقييم المعتمدة والتقيد بما جاء فيها والالتزام بالمواعيد المحددة بالتقييم والامتحانات.',
              'متابعة التقييمات والامتحانات للأبناء بشكل مستمر لرفع مستوى أدائهم على مدار العام الدراسي.',
              'التأكد من جاهزية الأبناء لأداء الامتحان (إحضار الأدوات اللازمة، شحن جهاز الحاسب الآلي/اللوحي).',
              'توعية الطالب بالالتزام بقواعد ولوائح تأدية الامتحان وعدم الغش أو تسريب أسئلة الامتحانات أو المشاركة فيها بأي شكل من الأشكال.',
              'التأكيد على الطالب بعدم استخدام الهاتف المتحرك أو الأجهزة الالكترونية الأخرى في القاعة الامتحانية.',
            ],
          },
          {
            title: 'الأنشطة والرعاية الطلابية',
            items: [
              'تشجيع الأبناء على المشاركة في الأنشطة الصفية واللّاصفية، والفعّاليات، والمبادرات الوطنيّة والعمل التطوعي والخدمة المجتمعية؛ لاكتساب وصقل المهارات العامة.',
            ],
          },
          {
            title: 'المواصلات',
            items: [
              'الالتزام باتباع جميع شروط السلامة والقواعد السلوكية ومواعيد النقل المدرسي التي اعتمدتها المدرسة.',
              'توجيه الأبناء إلى الالتزام بالسلوك الإيجابي في الحافلات المدرسية.',
              'الالتزام بتسديد قيمة أي تلفيات تسبب بها أبناؤه في الحافلة المدرسية.',
            ],
          },
          {
            title: 'الزي المدرسي',
            items: [
              'الالتزام بارتداء الأبناء الزّيَّ المدرسي الموحد من قبل الوزارة.',
              'التزام الأبناء بالمظهر اللائق والأنيق أثناء الدوام المدرسي.',
            ],
          },
          {
            title: 'الممتلكات العامة بالمدرسة',
            items: [
              'تعليم الأبناء قيمة المحافظة على الممتلكات العامة وأهميتها، وتحفيزهم على المحافظة عليها.',
              'توجيه الأبناء بعدم إلحاق أي أضرار متعمدة أو غير متعمدة بالممتلكات العامة في المدرسة.',
              'التعهد بالتعويض عن الأضرار الناجمة عن العبث بالممتلكات والمرافق التي قد يحدثها الطالب في المدرسة أو وسائل النقل.',
            ],
          },
          {
            title: 'الرسوم الدراسية: (للطلبة غير المواطنين)',
            items: [
              'الالتزام بدفع الرسوم الدراسية المترتبة على الأبناء كاملة في بداية العام الدراسي أو من خلال تقسيط المبلغ على ثلاث دفعات يتم تسديدها قبل بداية كل فصل دراسي وفقاً لشروط الاستحقاق المعتمدة لدى الوزارة، وفي حال عدم الالتزام، يحق للوزارة حجب النتائج الفصلية والنهائية وايقاف الخدمات المدرسية للطالب وإلغاء قيد الطالب للسنة الدراسية اللاحقة وفقاً للوائح المعتمدة ، كما يتحمل ولي الأمر كافة التبعات فيما يخص أحقية التعليم للطالب.',
            ],
          },
        ],
      },
    },
  },
};

export type Messages = typeof ar;
